(function () {
    var tagContainers = document.querySelectorAll('.part-category-listing__tag-container');

    tagContainers.forEach(item => {
        var tags = item.querySelectorAll('.part-category-listing__tag');

        if (tags.length > 3) {
            var tagsArr = Array.from(tags);
            var extraTags = tagsArr.slice(3);
            var moreTags = item.querySelector('.part-category-listing__more-tags');

            extraTags.forEach(et => et.classList.add('hidden'));

            moreTags.addEventListener('click', function() {
                extraTags.forEach(et => et.classList.remove('hidden'));
                this.classList.add('hidden');
            });
		}
    });
})();